import { createImmerReducer } from '../../reducers/utils/createReducer';
import * as c from './types';
import { HistoricalData } from '@models/historical';
import { MachineResponse, Machine } from '@models/machine';
import { MachineShift } from '_clean-code/services/contracts/shift.service';
import _ from 'lodash';

export type Status = 'idle' | 'loading' | 'success' | 'error';

export interface HistoricalDataById {
  [x: number]: {
    status: Status;
    data?: HistoricalData;
    error: any;
  };
}

export interface IMachineShift {
  id: number;
  title: string;
  start: Date;
  end: Date;
}

export interface HistoricalState {
  machines: {
    status: Status;
    data: Machine[];
    error?: any;
  };
  historical: HistoricalDataById;
  machineShifts: {
    [machineId: string]: IMachineShift[];
  };
}

const initialState: HistoricalState = {
  machines: {
    status: 'idle',
    data: [],
    error: undefined
  },
  historical: {},
  machineShifts: {}
};

export default createImmerReducer(initialState, {
  [c.GET_HISTORICAL_DATA_REQUEST]: (draft = initialState, { payload }) => {
    const { machineIds } = payload;
    draft.historical[machineIds[0] as number] = {
      status: 'loading',
      error: undefined
    };
  },
  [c.GET_HISTORICAL_DATA_SUCCESS]: (
    draft = initialState,
    { payload }: { payload?: HistoricalData[] }
  ) => {
    if (!payload) return;
    const historicalData = payload;
    for (const machineData of historicalData) {
      draft.historical[machineData.id] = {
        status: 'success',
        data: machineData,
        error: undefined
      };
    }
  },
  [c.GET_HISTORICAL_DATA_ERROR]: (draft, { payload }) => {
    const { params, error } = payload;
    const { id } = params;
    draft.historical[id] = { status: 'error', error };
  },
  [c.GET_HISTORICAL_MACHINES_REQUEST]: (draft: HistoricalState) => {
    draft.machines = { status: 'loading', error: undefined, data: [] };
  },
  [c.GET_HISTORICAL_MACHINES_SUCCESS]: (
    draft: HistoricalState,
    { payload }: { payload?: MachineResponse }
  ) => {
    if (!payload) return;
    const { machines } = payload;
    draft.machines = { data: machines, status: 'success' };
  },
  [c.GET_HISTORICAL_MACHINES_ERROR]: (draft: HistoricalState, { payload }) => {
    draft.machines = { data: [], error: payload, status: 'error' };
  },

  [c.GET_MACHINE_SHIFTS_SUCCESS]: (
    draft: HistoricalState,
    { payload: shifts }: { payload?: MachineShift[] }
  ) => {
    if (!shifts) return;
    const machineIds = _.uniq(shifts.map((x) => x.machineId));

    const machinesShifts = {};
    const now = new Date().getTime();
    machineIds.forEach((machineId) => {
      const filteredMachineShifts = shifts.filter(
        (x) =>
          x.machineId === machineId && x.end.getTime() < now && x.isConsidered
      );
      const machineShifts = _.orderBy(
        filteredMachineShifts,
        [(x) => x.start.getTime()],
        ['desc']
      );
      machinesShifts[machineId] = machineShifts;
    });

    draft.machineShifts = {
      ...draft.machineShifts,
      ...machinesShifts
    };
  }
});
